import { useState, useEffect } from 'react';
import { KidProfile, useKidsStore } from '../../store/kidsStore';
import { useTenant } from '../../contexts/TenantContext';

interface KidSelectorCardProps {
  profile: KidProfile;
  onSelect: (profile: KidProfile) => void;
}

export default function KidSelectorCard({ profile, onSelect }: KidSelectorCardProps) {
  const tenant = useTenant();
  const { canPlay } = useKidsStore();
  const [playStatus, setPlayStatus] = useState({
    can_play: true,
    tiempo_restante: 0,
    tiempo_jugado: 0
  });

  useEffect(() => {
    loadPlayStatus();
  }, [profile.id]);

  const loadPlayStatus = async () => {
    try {
      const status = await canPlay(profile.id);
      setPlayStatus({
        can_play: status.can_play,
        tiempo_restante: status.tiempo_restante || 0,
        tiempo_jugado: status.tiempo_jugado
      });
    } catch (error) {
      console.error('Error al verificar estado:', error);
    }
  };

  return (
    <div
      onClick={() => onSelect(profile)}
      className="bg-white rounded-3xl p-8 text-center cursor-pointer transition-all transform hover:scale-105 hover:shadow-2xl shadow-lg border-4 border-transparent hover:border-primary"
    >
      {/* Avatar grande */}
      <div
        className="w-24 h-24 rounded-full mx-auto mb-4 flex items-center justify-center text-6xl border-4"
        style={{
          background: tenant.theme.colors.gradients.main,
          borderColor: tenant.theme.colors.accent
        }}
      >
        {profile.avatar}
      </div>

      {/* Nombre */}
      <h3
        className="text-2xl font-bold mb-2"
        style={{ color: tenant.theme.colors.primary }}
      >
        {profile.nombre}
      </h3>

      {/* Edad */}
      <p className="text-gray-600 font-semibold mb-4">{profile.edad} años</p>

      {/* Estado de tiempo */}
      {playStatus.can_play ? (
        <div
          className="px-4 py-2 rounded-full text-sm font-semibold"
          style={{
            background: '#E6F7E6',
            color: '#4CAF50'
          }}
        >
          ⏰ {playStatus.tiempo_restante} min disponibles
        </div>
      ) : (
        <div
          className="px-4 py-2 rounded-full text-sm font-semibold"
          style={{
            background: '#FFE6E6',
            color: '#FF4444'
          }}
        >
          ⏰ Tiempo agotado hoy
        </div>
      )}
    </div>
  );
}
